
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import { useProfile } from "@/hooks/useProfile";
import { ProfileHeader } from "@/components/profile/ProfileHeader";
import { ProfileStats } from "@/components/profile/ProfileStats";
import { BadgesList } from "@/components/profile/BadgesList";
import { EditProfileDialog } from "@/components/profile/EditProfileDialog";

export default function ProfilePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { 
    profile,
    badges,
    stats,
    isEditDialogOpen,
    setIsEditDialogOpen,
    handleUpdateProfile,
    handleAvatarUpload,
  } = useProfile();

  useEffect(() => {
    if (!user) {
      navigate("/auth/login");
    }
  }, [user, navigate]);

  if (!profile) return null;

  return (
    <Layout>
      <div className="container py-8 space-y-8">
        <ProfileHeader
          displayName={profile.display_name}
          username={profile.username}
          avatarUrl={profile.avatar_url}
          disciplines={profile.disciplines}
          organisatie={profile.organisatie}
          yearsExperience={profile.years_experience}
          bio={profile.bio}
          onEditClick={() => setIsEditDialogOpen(true)}
        />

        <ProfileStats stats={stats} />
        
        <BadgesList badges={badges} />

        <EditProfileDialog
          open={isEditDialogOpen}
          onOpenChange={setIsEditDialogOpen}
          initialData={{
            displayName: profile.display_name || "",
            disciplines: profile.disciplines || "",
            organisatie: profile.organisatie || "",
            yearsExperience: profile.years_experience?.toString() || "",
            bio: profile.bio || "",
          }}
          onSubmit={handleUpdateProfile}
          userId={user.id}
          avatarUrl={profile.avatar_url}
          onAvatarUpload={handleAvatarUpload}
        />
      </div>
    </Layout>
  );
}
